import React from 'react';

const NumericKeypad = ({ onKeyPress }) => {
  const keys = [
    '1', '2', '3',
    '4', '5', '6',
    '7', '8', '9',
    'C', '0', '←' // C para Clear, ← para Backspace
  ];

  return (
    <div className="grid grid-cols-3 gap-2 p-2 bg-gray-100 rounded-lg shadow-inner">
      {keys.map((key) => (
        <button
          key={key}
          onClick={() => onKeyPress(key)}
          className={`
            py-4 rounded-lg font-semibold text-2xl transition-colors
            ${key === 'C' ? 'bg-red-500 text-white hover:bg-red-600' :
              key === '←' ? 'bg-blue-500 text-white hover:bg-blue-600' :
              'bg-white text-gray-800 hover:bg-gray-200'}
            shadow-sm active:shadow-md active:scale-95
          `}
        >
          {key}
        </button>
      ))}
    </div>
  );
};

export default NumericKeypad;